import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';

export default class HotelSettingsMyPropertyIndexRoute extends Route {
  @service declare router: Services['router'];

  redirect(): void {
    void this.router.transitionTo('hotel.settings.my-property.hotel-details');
  }
}
